import {
  FetchLeaderboardStatistics,
  FetchLeaderboardStatisticsVariables,
} from "_graphql/queries/__generated__/FetchLeaderboardStatistics";

import { fetchLeaderboardStats } from "_graphql/visal/queries/leaderboard";
import { useQuery } from "@apollo/client";

export const useLeaderboardStatistics = ({
  brokerId,
  year = new Date().getFullYear(),
}: {
  brokerId: string;
  year?: number;
}) => {
  const { data, loading, error, refetch } = useQuery<
    FetchLeaderboardStatistics,
    FetchLeaderboardStatisticsVariables
  >(fetchLeaderboardStats, {
    variables: {
      brokerId,
      year,
    },
    fetchPolicy: "network-only",
    skip: !brokerId,
  });
  return {
    leaderboard: data?.fetchLeaderboardStatistics || null,
    totalCashAccumulated:
      data?.fetchTotalCashAccumulated?.total_cash_accumulated || 0,
    loading,
    error,
    refetch,
  };
};
